import { FormControl, InputAdornment } from '@mui/material';
import { StyledOutlinedInput } from 'components/atoms';
import React, { ChangeEvent } from 'react';
import { MdSearch } from 'react-icons/md';

import { SearchInputProps } from './types';

export const SearchInput = ({
  onSearch,
  placeholder = 'Search',
  showIcon = true,
  inputCss,
  wrapperCss,
  value = '',
}: SearchInputProps) => {
  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    onSearch(newValue);
  };

  return (
    <FormControl style={wrapperCss}>
      <StyledOutlinedInput
        value={value}
        onChange={handleSearchChange}
        placeholder={placeholder}
        style={inputCss}
        inputProps={{ 'data-testid': 'table-search' }}
        startAdornment={
          showIcon ? (
            <InputAdornment position="start">
              <MdSearch />
            </InputAdornment>
          ) : null
        }
      />
    </FormControl>
  );
};
